import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { FlexBetween, HideScrollbar } from '../../../../global/commonStyle';

interface Props {
  isHide?: boolean;
  isLastChild?: boolean;
}

const Container = styled.div`
  display: flex;
  height: 100%;
  gap: var(--space-16);
`;

const MainContent = styled.div`
  padding: var(--space-20) var(--space-24) var(--space-0);
  height: calc(100dvh - 67px);
  ${HideScrollbar}
  ${mobile_xl(css`
    box-sizing: border-box;
    padding: var(--space-8) var(--space-0) var(--space-0) var(--space-20);
    height: calc(100dvh - 48px);
  `)}
`;
const BoxModel = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  max-width: 346px;
  :last-child {
    padding-right: var(--space-20);
  }
  .virtuoso-css {
    height: calc(100dvh - 104px) !important;
    width: 100%;
    overflow-x: hidden;
  }
`;

const Header = styled.div`
  width: 328px;
  ${FlexBetween}
  ${(props: Props) =>
    props.isHide &&
    css`
      display: none;
    `}
`;

const Title = styled.h1`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const BlockContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-10);
`;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  max-height: calc(100dvh - 98px);
  height: 100vh;
  ${HideScrollbar}
  ${mobile_xl(css`
    max-height: calc(100dvh - 95px);
  `)}
`;

const ShowHide = styled.a`
  ${Typography.body_md}
  color: var(--text-secondary);
  cursor: pointer;
  max-width: 146px;
  width: 100%;
  padding-top: var(--space-4);
  padding-bottom: var(--space-12);
  &:hover {
    color: var(--text-primary);
  }
  ${mobile_xl(css`
    max-width: max-content;
    &.update-padding {
      padding-bottom: var(--space-96);
    }
  `)}
`;
const ShowTask = styled.div`
  display: flex;
  flex-direction: column;
`;

const TaskContainer = styled.div<Props>`
  padding-bottom: ${({ isLastChild }) => (isLastChild ? 'var(--space-12)' : 'var(--space-10)')};
  ${mobile_xl(css<Props>`
    padding-bottom: ${({ isLastChild }) => (isLastChild ? 'var(--space-96)' : 'var(--space-10)')};
  `)}
`;

export { Container, BoxModel, Header, Title, BlockContent, MainContent, Div, ShowHide, ShowTask, TaskContainer };
